import { DataBean } from "../DataBean";

export class UpdateStandardImp extends DataBean {



    public async updateProductionOrderStandardImp(year:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateProductionOrderStandardImp_Number_Number", [year,idEmployee]);
    }
     public async updateProductionOrderStandardImpbyorder(idProductionOrder:any,productionOrderDate:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateProductionOrderStandardImp_Number_java.util.Date_Number", [idProductionOrder,productionOrderDate,idEmployee]);
    }

      public async importRawMaterialProductionOrderInitialLefts(filename:any,directory:any,dataStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importRawMaterialProductionOrderInitialLefts_String_String_String", [filename,directory,dataStore]);
    }
      public async importCostProductionOrderInitialLefts(filename:any,directory:any,dataStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importCostProductionOrderInitialLefts_String_String_String", [filename,directory,dataStore]);
    }
      public async importWIPProductInitialLefts(filename:any,directory:any,dataStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importWIPProductInitialLefts_String_String_String", [filename,directory,dataStore]);
    }

      public async importFinishedProductInitialLefts(filename:any,directory:any,dataStore:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_importFinishedProductInitialLefts_String_String_String", [filename,directory,dataStore]);
    }
}